import React from "react";
import { useActor } from "@xstate/react";
import MultiSelect from "../MultiSelect";
import { Button } from "../SignUpButton";
import { useSignUpMachine } from "../../context/SignUpMachineContext";
import { SignUpFormField } from "../../constants/signup-form-field.enum";
import { BusinessNeedsValue } from "../../constants/signup-value.enum";

const BusinessNeedsStep: React.FC = () => {
  const machine = useSignUpMachine();
  const [state, send] = useActor(machine);
  const { formData } = state.context;

  const businessNeedsValue = formData[SignUpFormField.BusinessNeeds] || [];

  const handleChange = (value: string[]) => {
    send({
      type: "UPDATE_FORM",
      data: { [SignUpFormField.BusinessNeeds]: value },
    });
  };

  const handleSubmit = () => {
    send({ type: "NEXT" });
  };

  const field = {
    id: SignUpFormField.BusinessNeeds,
    required: true,
    options: [
      {
        id: "input-business-needs-lead-gen-conversion",
        label: "Attracting & converting leads",
        value: BusinessNeedsValue.LeadGenerationAndConversion,
      },
      {
        id: "input-business-needs-workout-tracking",
        label: "Workout tracking",
        value: BusinessNeedsValue.WorkoutTracking,
      },
      {
        id: "input-business-needs-branded-members-app",
        label: "Branded members app",
        value: BusinessNeedsValue.BrandedMembersApp,
      },
      {
        id: "input-business-needs-gym-website",
        label: "Building a custom gym website",
        value: BusinessNeedsValue.GymWebsite,
      },
      {
        id: "input-business-needs-manage-billing",
        label: "Managing billing",
        value: BusinessNeedsValue.ManageBilling,
      },
      {
        id: "input-business-needs-communication",
        label: "Communicating with members",
        value: BusinessNeedsValue.CommunicatingWithMembers,
      },
      {
        id: "input-business-needs-product-sales",
        label: "Selling products",
        value: BusinessNeedsValue.ProductSales,
      },
      {
        id: "input-business-needs-other",
        label: "Other",
        value: BusinessNeedsValue.Other,
      },
    ],
  };

  const canProceed = businessNeedsValue.length > 0;

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <h2 className="tw-text-xl">What problems can we help you solve?</h2>
        <p className="tw-text-gray-400 tw-text-base">Select all that apply</p>
      </div>
      <div className="tw-space-y-4">
        <MultiSelect
          options={field.options}
          onChange={handleChange}
          value={businessNeedsValue}
        />
      </div>
      <div className="tw-flex tw-justify-between tw-items-center">
        <Button
          onClick={handleSubmit}
          disabled={!canProceed}
          size="fat"
          className="tw-uppercase tw-tracking-widest tw-w-full tw-flex tw-py-4 tw-items-center tw-gap-2 tw-text-white"
        >
          <span>Next</span>
        </Button>
      </div>
    </>
  );
};

export default BusinessNeedsStep;
